import ProtectedButton from 'containers/Common/ProtectedButton';
import React, { FC, memo } from 'react';
import { Props } from './types';

const SubmitButton: FC<Props> = ({ url, ...rest }) => (
  <ProtectedButton to={{ hash: '#accept-challenge', pathname: url }} {...rest}>
    Submit your entry
  </ProtectedButton>
);

export default memo(SubmitButton);
